import { toast } from "react-toastify";

export const NotifyError = (message) => {
  toast.error(message, {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    bodyClassName: "toastBodyError",
  });
};

export const NotifySuccess = (message) => {
  toast.success(message, {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    bodyClassName: "toastBodySuccess",
  });
};

export const NotifyErrorDark = (message) => {
  toast.error(message, {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    bodyClassName: "toastBodyError",
  });
};

export const NotifySuccessDark = (message) => {
  toast.success(message, {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    bodyClassName: "toastBodySuccess",
  });
};

export const NotifyPending = (message) => {
  toast.loading(message, {
    position: "bottom-right",
    theme: "light",
    bodyClassName: "toastBodyPending",
  });
};
